module.exports = __webpack_public_path__ + "static/original-mattress-2-c49e0ea156f42f41a9a02be98c028083.png";